import { ApexStyleQuiz } from "@/features/game/components/style-quiz";

export function ApexStylePage() {
  return <ApexStyleQuiz />;
}
